import { useLocalLogic } from "~/context/clientProvider";
import { useQuery } from "@tanstack/react-query";
import { useFlags } from "launchdarkly-react-client-sdk";
import { poisKeys, poisResponse } from "~/features/pois";
import { type POIGroup } from "../types";

type Options = {
  lat?: number;
  lng?: number;
  include?: POIGroup;
  radius?: number;
};

export function usePois({ lat, lng, include, radius = 2000 }: Options) {
  const flags = useFlags();
  const { client } = useLocalLogic();

  const options = {
    lat,
    lng,
    limit: 50,
    attemptMinimum: flags.lcMinimumPoi ? 3 : undefined,
    radius,
    include,
  };

  return useQuery({
    queryKey: poisKeys.list(options),
    queryFn: async () => client.getPois(options as unknown as poisResponse),
    enabled:
      !!options && !!options.include?.length && !!options.lat && !!options.lng,
  });
}
